<script type="text/ecmascript-6">
    import DesignerQuestionDoorGlassLaminated from "./DesignerQuestionDoorGlassLaminated.vue";
    import RadioSwitchQuestion from "../mixin/RadioSwitchQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionDoorGlassLaminated,
            RadioSwitchQuestion,
        ],
        props: {
            securedByDesign: {
                required: true,
            },
            title: {
                default() {
                    return 'Laminated Glass'
                }
            }
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/laminated-glass?secured_by_design=' + this.securedByDesign + '&slab=' + this.slab + '&left=' + this.get_side('left') + '&right=' + this.get_side('right') + '&top=' + this.get_side('top') + '&comp_left=' + this.get_side('left_composite_id') + '&comp_right=' + this.get_side('right_composite_id');
            },
            passed_filter(){
                return this.variable_ready(this.securedByDesign, this.slab, this.frameStyle, this.sidePanels);
            },
            cache_key(){
                return '_' + this.securedByDesign + '_' + this.slab + '_' + this.get_side('left') + '_' + this.get_side('right') + '_' + this.get_side('top') + '_' + this.get_side('left_composite_id') + '_' + this.get_side('right_composite_id');
            },
        },
        watch: {
            'securedByDesign': function (val, oldVal) {
                this.update_options();
            }
        }
    }
</script>
